import React, { Component } from 'react';
import { Container } from 'reactstrap';
import ContentLoader from "../../components/ContentLoader";
import MetaTags from '../../components/SEO/MetaTags'
import { Request } from '../../helpers/request'
import { FormattedMessage } from 'react-intl'
import { MODAL_RGPD_COOKIES_KEY } from '../../components/RgpdCookies/RgpdCookiesModal'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'

class TermsPage extends Component
{
    state = {
        data: null
    };

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        Request.get('cgu')
            .then((data) => {
                this.setState({ data })
            })
            .catch((e) => {
                this.props.history.push(addLocalePrefix('/404'));
            });
    }
    renderContent = () =>
    {
        const {data} = this.state;

        if (!data)
            return <ContentLoader/>;

        return (
            <>
                <h1 className="line-heading">
                    { data.title }
                </h1>
                <div className='notice-text' dangerouslySetInnerHTML={{__html: data.content}}/>
            </>
        )
    };

    renderRgpdCookiesSection() {
        return (
            <div className='notice-text'>
                <h2>
                    <FormattedMessage id="rgpd-cookies.cgu.title" />
                </h2>
                <p>
                    <FormattedMessage id="rgpd-cookies.cgu.description" />{' '}
                    <LocaleLink to={{
                        pathname: '/cgu',
                        search: `?modal=${MODAL_RGPD_COOKIES_KEY}`
                    }}>
                        <FormattedMessage id="rgpd-cookies.cgu.link" />
                    </LocaleLink>
                </p>
            </div>
        )
    }

    render()
    {
        return (
            <div className="terms-page">

            <MetaTags page="terms" />

                <section className="section-terms">
                    <Container>
                        {this.renderContent()}
                        {this.renderRgpdCookiesSection()}
                    </Container>
                </section>
            </div>
        )
    }

}

export default TermsPage;
